











import {
  computed,
  defineComponent,
  getCurrentInstance
} from "@vue/composition-api";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  props: {
    maxHeight: {
      type: [Number, String],
      default: undefined
    },
    maxWidth: {
      type: [Number, String],
      default: undefined
    },
    minHeight: {
      type: [Number, String],
      default: undefined
    },
    minWeight: {
      type: [Number, String],
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    width: {
      type: [Number, String],
      default: undefined
    },
    rounded: {
      type: [Boolean, String],
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    boxshadow: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: null
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const panelStyle = computed(() => {
      const style = {
        "max-height": props.maxHeight,
        "max-width": props.maxWidth,
        "min-height": props.minHeight,
        "min-width": props.minWeight,
        height: props.height,
        width: props.width,
        "border-radius": props.rounded
      };
      return props.customStyle ? { ...style, ...props.customStyle } : style;
    });
    const classes = computed(() => [
      {
        "occ-panel--rounded": props.rounded,
        "occ-panel--outlined": props.outlined,
        "occ-panel--border": props.border,
        "occ-panel--boxshadow": props.boxshadow
      }
    ]);

    const instance = getCurrentInstance();
    const handleClick = () => {
      if (instance) sendGaEvent(instance.proxy);
      emit("click");
    };
    return { panelStyle, classes, handleClick };
  }
});
